import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import {
  getApplication,
  getEnviroment,
  getIsStartSentry,
} from "../enviromentUtils";

const sentryAlreadyCalled = () => {
  let initAlreadyCalled = false;
  const __sentry = window["__SENTRY__"];
  if (
    !(typeof __sentry === "undefined") &&
    __sentry.hub &&
    __sentry.hub.getClient()
  ) {
    initAlreadyCalled = true;
  }
  return initAlreadyCalled;
};

export const initSentry = () => {
  if (!sentryAlreadyCalled() && getIsStartSentry()) {
    Sentry.init({
      dsn: "https://8de38c7d9b94467dbd9103740f1eec8b@sentry.starcharge.com/103",
      environment: getEnviroment(),
      release: getApplication(),
      integrations: [
        new Integrations.BrowserTracing({
          tracingOrigins: ["::1"],
          beforeNavigate: (context) => {
            context.name = window.location.pathname;
            return context;
          },
        }),
      ],
      tracesSampleRate: 1.0,
    });
  }
};

export const captureException = (err: string) => {
  Sentry.captureException(err);
};
